__turbopack_context__.v({
  "buttonsWrapper": "ColumnsItem-module-scss-module__DxTl9a__buttonsWrapper",
  "columnsItem": "ColumnsItem-module-scss-module__DxTl9a__columnsItem",
  "text": "ColumnsItem-module-scss-module__DxTl9a__text",
  "title": "ColumnsItem-module-scss-module__DxTl9a__title",
});
